<template>
    <svg
        :viewBox="svgViewBoxValues"
        :class="getClasses"
        :height="getHeight"
        :width="getWidth"
        :aria-hidden="getAriaHidden"
        :fill="getFill"
        xmlns="http://www.w3.org/2000/svg"
        v-html="svgContent"
    >
    </svg>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            svgString: this.getIconContent(this.icon)
        }
    },
    computed: {
        svgViewBoxValues() {
            return this.svgString ? (/viewBox="([^"]+)"/.exec(this.svgString) || '')[1] : null
        },
        getClasses() {
            return this.svgString ? (/class="([^"]+)"/.exec(this.svgString) || '')[1] : null
        },
        getHeight() {
            return this.svgString ? (/height="([^"]+)"/.exec(this.svgString) || '')[1] : null
        },
        getWidth() {
            return this.svgString ? (/width="([^"]+)"/.exec(this.svgString) || '')[1] : null
        },
        getAriaHidden() {
            return this.svgString ? (/aria-hidden="([^"]+)"/.exec(this.svgString) || '')[1] : null
        },
        getFill() {
            if (this.svgString && (/fill="none" xmlns/.exec(this.svgString || ''))) {
                return 'none'
            } else {
                return false
            }
        },
        svgContent() {
            return this.svgString ? this.svgString.replace(/^<svg[^>]*>|<\/svg>$/g, '') : null
        }
    },
    watch: {
        icon(icon) {
            this.svgString = this.getIconContent(icon)
        }
    },
    methods: {
        getIconContent(icon) {
            return require(`svg-files-path/${this.getIconPath(icon)}`).default
        },
        getIconPath(icon) {
            return icon.replace(new RegExp('.'.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'), 'g'), '/') + '.svg'
        },
    }
}
</script>
